import React from 'react';
import { useTranslation } from 'react-i18next';

const Step5ReviewSubmit = ({ formData, onSubmit, loading }) => {
  const { t } = useTranslation();

  const renderField = (labelKey, value) => (
    <div className="mb-2">
      <span className="block text-sm font-medium text-gray-600 dark:text-gray-300">
        {t(labelKey)}
      </span>
      <div className="text-base text-gray-800 dark:text-gray-100">
        {value?.trim() ? value : '-'}
      </div>
    </div>
  );

  const Section = ({ titleKey, children }) => (
    <div>
      <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-3">
        {t(titleKey)}
      </h3>
      <div className="space-y-2">{children}</div>
    </div>
  );

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
        {t('partnerJoin.step5.title')}
      </h2>

      <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-md space-y-6 transition-colors duration-300">
        <Section titleKey="partnerJoin.step5.section.general">
          {renderField('partnerJoin.step5.name', formData.name)}
          {renderField('partnerJoin.step5.category', formData.category)}
          {renderField('partnerJoin.step5.type', formData.type)}
          {renderField('partnerJoin.step5.website', formData.website)}
        </Section>

        <Section titleKey="partnerJoin.step5.section.location">
          {renderField('partnerJoin.step5.address', formData.fullAddress || formData.address)}
          {renderField('partnerJoin.step5.subdistrict', formData.subdistrict || formData.region)}
          {renderField('partnerJoin.step5.district', formData.district)}
          {renderField('partnerJoin.step5.city', formData.city)}
          {renderField('partnerJoin.step5.province', formData.province)}
        </Section>

        <Section titleKey="partnerJoin.step5.section.contact">
          {renderField('partnerJoin.step5.picName', formData.picName)}
          {renderField('partnerJoin.step5.picPosition', formData.picPosition)}
          {renderField('partnerJoin.step5.phone', formData.phone)}
          {renderField('partnerJoin.step5.email', formData.email)}
        </Section>

        <Section titleKey="partnerJoin.step5.section.legal">
          {renderField('partnerJoin.step5.legalStatus', formData.legalStatus)}
          {renderField('partnerJoin.step5.legalNumber', formData.legalNumber)}
        </Section>

        <Section titleKey="partnerJoin.step5.section.waste">
          {renderField('partnerJoin.step5.acceptedWaste', formData.acceptedWaste)}
          {renderField('partnerJoin.step5.incentiveSystem', formData.incentiveSystem)}
          {renderField('partnerJoin.step5.transactionSystem', formData.transactionSystem)}
        </Section>
      </div>

      <button
        type="button"
        onClick={onSubmit}
        disabled={loading}
        className={`w-full py-3 px-6 rounded-xl font-semibold transition text-white ${
          loading
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-primaryAccent hover:bg-primaryAccent/90'
        }`}
      >
        {loading
          ? t('partnerJoin.step5.loading')
          : t('partnerJoin.step5.submit')}
      </button>
    </div>
  );
};

export default Step5ReviewSubmit;
